module.exports = __webpack_public_path__ + "static/mo36-e840f5a187a71802aa8edbde7ff34819.png";